export class KeyLog {
    static fromExistingData(kLog: any): KeyLog {
        const keyLog = new KeyLog();

        if (kLog.keyTag) keyLog.keyTag = kLog.keyTag;
        if (kLog.building) keyLog.buildingId = +kLog.building.bdId;
        if (kLog.building) keyLog.buildingName = kLog.building.name;
        if (kLog.id) keyLog.id = +kLog.id;
        if (kLog.otherResident) keyLog.otherResident = kLog.otherResident;
        if (kLog.otherSuite) keyLog.otherSuite = kLog.otherSuite;
        if (kLog.resident) keyLog.residentId = +kLog.resident.bdId;
        if (kLog.resident) keyLog.residentFullName = kLog.resident.fullName;
        if (kLog.suite) keyLog.suiteId = +kLog.suite.bdId;
        if (kLog.suite) keyLog.suiteNumber = kLog.suite.suiteNumber;
        if (kLog.notes) keyLog.notes = kLog.notes;
        if (kLog.purpose) keyLog.purpose = kLog.purpose;
        if (kLog.status) keyLog.status = kLog.status;
        keyLog.isCanEdit = kLog.isCanEdit;
        keyLog.isCanDelete = kLog.isCanDelete;
        return keyLog;
    }

    constructor(
        public id: number = null,
        public suiteId: number = null,
        public suiteNumber: string = '',
        public returningByName: string = '',
        public buildingId: number = null,
        public buildingName: string = '',
        public residentId: number = null,
        public residentFullName: string = '',
        public otherResident: string = '',
        public otherSuite: string = '',
        public status: string = '',
        public notes: string = '',
        public purpose: string = '',
        public keyTag: string = '',
        public user: string = '',
        public activityNotes: string = '',
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public formFields = {
            unit: {editMode: false}
        }
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/KeyLog.ts